import React from 'react';
import { Link } from 'react-router-dom';
import heroImage from '../assets/ppe_hero_CovidTests.webp';

const Banner: React.FC = () => {
    return (
        <div className="w-full">
            <Link to="/covid-19-test-kits.html" className="block">
                <img 
                    src={heroImage} 
                    alt="COVID-19 Test Kits - PPE.US" 
                    className="w-full h-auto object-cover cursor-pointer hover:opacity-95 transition-opacity duration-200"
                    loading="lazy"
                />
            </Link>
        </div>
    );
};

export default Banner; 